/**
 * Module dependencies
 */
const { CancelToken, isCancel } = require('axios');

/**
 * Expose CancelToken & isCancel
 */
exports.CancelToken = CancelToken;
exports.isCancel = isCancel;
